// Package Option Variant ID : Real Product's Variant ID
var PRODUCT_MAPPING = {
  /******** Meters ********/
  
  // Meter
  '9050927431741': '7645601103933', // EKM-Omnimeter I v.3 – Universal Smart Meter, Single Phase or 3-Phase, 120 to 480V, 50/60Hz, up to 5000
  '9050927464509': '7645603004477', // EKM-Omnimeter II UL v.3 – Universal Smart Meter, Single Phase or 3-Phase, 120 to 240V, 50/60Hz, up to 5000 Amps
  '9050927497277': '7645603364925', // EKM Omnimeter Pulse v.4 – Pulse Counting, Relay Controlling, Universal Smart Electric Meter
  '9050927530045': '7645607755837', // EKM Omnimeter Pulse UL v.4 – Pulse Counting, Relay Controlling, Universal Smart Electric Meter, UL Listed, ANSI
  
  // Pulse Meter
  '12290466349117': '7645603364925', // EKM Omnimeter Pulse v.4 – Pulse Counting, Relay Controlling, Universal Smart Electric Meter
  '12290466512957': '7645607755837', // EKM Omnimeter Pulse UL v.4 – Pulse Counting, Relay Controlling, Universal Smart Electric Meter, UL Listed, ANSI  
  '40965512429629': '40767299813437', // ioStack (beta) - Pulse Counting, Sensor Input/Output, and Control Hub 
  
  // Water and Gas Meters
  '12290478112829': '7645605625917', // 3/4" Water Meter - Stainless Steel, Pulse Output
  '12290478178365': '7645606903869', // 3/4" Hot Water Meter - Stainless Steel, Pulse Output
  '12470702080061': '7645591339069', // 3/4" Water Meter - Stainless Steel, High Definition Pulse Output
  '12470713483325': '7645192847421', // 3/4" Hot Water Meter - Stainless Steel, High Definition Pulse Output
  '12290478211133': '7645145595965', // 3/4" Vertical Water Meter - Stainless Steel, High Definition Pulse Output
  '12290478243901': '7645088809021', // 3/4" Vertical Hot Water Meter - Stainless Steel, High Definition Pulse Output
  '12290478309437': '7645606084669', // 1" Water Meter - Stainless Steel, Pulse Output
  '12290478407741': '7645606379581', // 1.5" Water Meter - Stainless Steel, Pulse Output
  '12290478440509': '7645606641725', // 2" Water Meters - Stainless Steel, Pulse Output
  '12290478506045': '7645600415805', // 3/4" Pulse Output Gas Meter - PGM-075
  '40027586723901': '39300161077309', // 3/4" Aluminum Pulse Output Gas Meter - APGM-075
  '39345120215101': '39300159537213', // 1.5" Pulse Output Gas Meter - PGM-150-CF
  '33029374050365': '33025363869757', // SPWM-075-HD-NSF - 3/4" NSF Water, Meter Stainless Steel, Pulse Output
  '33029374246973': '33025364557885', // VSPWM-075-HD-NSF - 3/4" Vertical NSF Water, Meter Stainless Steel, Pulse Output
  '33029376114749': '33025364852797', // SPWM-100-NSF - 1.0" NSF Water, Meter Stainless Steel, Pulse Output
  '33029376606269': '33025365311549', // SPWM-150-NSF - 1.5" NSF Water, Meter Stainless Steel, Pulse Output
  '33029377130557': '33025369178173', // SPWM-200-NSF - 2.0" NSF Water, Meter Stainless Steel, Pulse Output
  
  // Additional Water and Gas Meters 1
  '12290501083197': '7645605625917', // 3/4" Water Meter - Stainless Steel, Pulse Output
  '12290501148733': '7645606903869', // 3/4" Hot Water Meter - Stainless Steel, Pulse Output
  '12471373267005': '7645591339069', // 3/4" Water Meter - Stainless Steel, High Definition Pulse Output
  '12471380738109': '7645192847421', // 3/4" Hot Water Meter - Stainless Steel, High Definition Pulse Output
  '12290501247037': '7645145595965', // 3/4" Vertical Water Meter - Stainless Steel, High Definition Pulse Output
  '12290501312573': '7645088809021', // 3/4" Vertical Hot Water Meter - Stainless Steel, High Definition Pulse Output
  '12290501410877': '7645606084669', // 1" Water Meter - Stainless Steel, Pulse Output
  '12290501443645': '7645606379581', // 1.5" Water Meter - Stainless Steel, Pulse Output
  '12290501673021': '7645606641725', // 2" Water Meters - Stainless Steel, Pulse Output
  '12290501738557': '7645600415805', // 3/4" Pulse Output Gas Meter - PGM-075
  '40027596193853': '39300161077309', // 3/4" Aluminum Pulse Output Gas Meter - APGM-075
  '39345118642237': '39300159537213', // 1.5" Pulse Output Gas Meter - PGM-150-CF
  '33029385257021': '33025363869757', // SPWM-075-HD-NSF - 3/4" NSF Water, Meter Stainless Steel, Pulse Output
  '33029385420861': '33025364557885', // VSPWM-075-HD-NSF - 3/4" Vertical NSF Water, Meter Stainless Steel, Pulse Output
  '33029385584701': '33025364852797', // SPWM-100-NSF - 1.0" NSF Water, Meter Stainless Steel, Pulse Output
  '33029386960957': '33025365311549', // SPWM-150-NSF - 1.5" NSF Water, Meter Stainless Steel, Pulse Output
  '33029387026493': '33025369178173', // SPWM-200-NSF - 2.0" NSF Water, Meter Stainless Steel, Pulse Output
  
  // Additional Water and Gas Meters 2
  '12290505867325': '7645605625917', // 3/4" Water Meter - Stainless Steel, Pulse Output
  '12290505965629': '7645606903869', // 3/4" Hot Water Meter - Stainless Steel, Pulse Output
  '12471434182717': '7645591339069', // 3/4" Water Meter - Stainless Steel, High Definition Pulse Output
  '12471428513853': '7645192847421', // 3/4" Hot Water Meter - Stainless Steel, High Definition Pulse Output
  '12290505998397': '7645145595965', // 3/4" Vertical Water Meter - Stainless Steel, High Definition Pulse Output
  '12290506129469': '7645088809021', // 3/4" Vertical Hot Water Meter - Stainless Steel, High Definition Pulse Output
  '12290506162237': '7645606084669', // 1" Water Meter - Stainless Steel, Pulse Output
  '12290506227773': '7645606379581', // 1.5" Water Meter - Stainless Steel, Pulse Output
  '12290506260541': '7645606641725', // 2" Water Meters - Stainless Steel, Pulse Output
  '12290506457149': '7645600415805', // 3/4" Pulse Output Gas Meter - PGM-075
  '40027598487613': '39300161077309', // 3/4" Aluminum Pulse Output Gas Meter - APGM-075
  '39345119363133': '39300159537213', // 1.5" Pulse Output Gas Meter - PGM-150-CF
  '33029387845693': '33025363869757', // SPWM-075-HD-NSF - 3/4" NSF Water, Meter Stainless Steel, Pulse Output
  '33029387976765': '33025364557885', // VSPWM-075-HD-NSF - 3/4" Vertical NSF Water, Meter Stainless Steel, Pulse Output
  '33029388271677': '33025364852797', // SPWM-100-NSF - 1.0" NSF Water, Meter Stainless Steel, Pulse Output
  '33029388730429': '33025365311549', // SPWM-150-NSF - 1.5" NSF Water, Meter Stainless Steel, Pulse Output
  '33029388861501': '33025369178173', // SPWM-200-NSF - 2.0" NSF Water, Meter Stainless Steel, Pulse Output
  
  // It seems after you first make the product in Bold, you can add options that are actual products
  // Going to map those products to themselves so the existing code still works
  '7645605625917': '7645605625917', // 3/4" Water Meter - Stainless Steel, Pulse Output
  '7645606903869': '7645606903869', // 3/4" Hot Water Meter - Stainless Steel, Pulse Output
  '7645591339069': '7645591339069', // 3/4" Water Meter - Stainless Steel, High Definition Pulse Output
  '7645192847421': '7645192847421', // 3/4" Hot Water Meter - Stainless Steel, High Definition Pulse Output
  '7645608149053': '7645608149053', // 1.5" Pulse Output Gas Meter - PGM-150
  
  /******** CTs ********/
  
  // Current Transformer
  '32893772136509': '29380251975741', // Solid-core CT, 200A, 200A:26.6mA, 13mm (0.51") Hole Diameter, EBCT-013-200UL
  '9033219211325': '7645601464381', // Solid-core CT, 200A, 200A:26.6mA, 15mm (0.59") Hole Diameter, BCT-015-200
  '40253585457213': '29380260495421', // Split-Core CT, 200A, 200A:26.6mA, 15mm (0.6") Hole Diameter, ESCT-015-200UL
  '40253584310333': '29380257382461', // Solid-Core CT, 200A, 200A:26.6mA, 19mm (0.75") Hole Diameter, EBCT-019-200UL
  '9033219276861': '7645601071165', // Solid-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-200
  '9033219309629': '7645059219517', // Piercing Split-Core Current Transformer, 200A, 200A:26.6mA, 19mm (0.748") Hole Diameter, PSCT-019-200
  '9033219342397': '7645608345661', // Split-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, SCT-025-200
  '32084156710973': '29380260790333', // Split-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, ESCT-025-400UL
  '9033219407933': '7645601726525', // Solid-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-400
  '9033219440701': '7645601824829', // Split-core CT, 400A, 400A:26.6mA, 32mm (1.26") Hole Diameter, SCT-032-400
  '9033219473469': '7645601857597', // Solid-core CT, 600A, 600A:26.6mA, 45mm (1.77") Hole Diameter, BCT-045-600
  '29382105595965': '29380261871677', // Split-core CT, 600A, 600A:26.6mA, 55mm (2.17") Hole Diameter, ESCT-055-600
  '9033219506237': '7645601923133', // Split-core CT, 800A, 800A:26.6mA, 65mm (2.56") Hole Diameter, SCT-065-800
  '9033219539005': '7645601890365', // Solid-core CT, 800A, 800A:26.6mA, 80mm (3.15") Hole Diameter, BCT-080-800
  '40540641460285': '39342394441789', // Split-core Outdoor CT, 800A, 800A:26.6mA, 63x33mm (2.48"x1.3") Hole Diameter, OSCT-063x033-800
  '31186899664957': '29380262494269', // Split-Core CT, 1500A, 1500A:26.6mA, 90x50mm (3.54x1.97") Hole Diameter, ESCT-090x050-1500
  '29491130531901': '29380263575613', // Split-core CT, 3000A, 3000A:26.6mA, 120x80mm (4.72x3.15") Hole Diameter, ESCT-120x080-3000
  '9033219670077': '7645608443965', // Split-Core CT, 5000A, 5000A:26.6mA, 180mm(7.09") x 130mm(5.12") Hole Diameter SCT-180x130-5000
  
  // Current Transformer x2
  '32893797630013': {variantId: '29380251975741', quantity: 2}, // Solid-core CT, 200A, 200A:26.6mA, 13mm (0.51") Hole Diameter, EBCT-013-200UL
  '9050962067517': {variantId: '7645601464381', quantity: 2}, // Solid-core CT, 200A, 200A:26.6mA, 15mm (0.59") Hole Diameter, BCT-015-200
  '40253597384765':  {variantId: '29380260495421', quantity: 2}, // Split-Core CT, 200A, 200A:26.6mA, 15mm (0.6") Hole Diameter, ESCT-015-200UL
  '40253598826557':  {variantId: '29380257382461', quantity: 2}, // Solid-Core CT, 200A, 200A:26.6mA, 19mm (0.75") Hole Diameter, EBCT-019-200UL
  '9050962100285': {variantId: '7645601071165', quantity: 2}, // Solid-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-200
  '9050962133053': {variantId: '7645059219517', quantity: 2}, // Piercing Split-Core Current Transformer, 200A, 200A:26.6mA, 19mm (0.748") Hole Diameter, PSCT-019-200
  '9050962165821': {variantId: '7645608345661', quantity: 2}, // Split-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, SCT-025-200
  '32084170407997': {variantId: '29380260790333', quantity: 2}, // Split-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, ESCT-025-400UL
  '9050962231357': {variantId: '7645601726525', quantity: 2}, // Solid-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-400
  '9050962264125': {variantId: '7645601824829', quantity: 2}, // Split-core CT, 400A, 400A:26.6mA, 32mm (1.26") Hole Diameter, SCT-032-400
  '9050962395197': {variantId: '7645601857597', quantity: 2}, // Solid-core CT, 600A, 600A:26.6mA, 45mm (1.77") Hole Diameter, BCT-045-600
  '29382176997437': {variantId: '29380261871677', quantity: 2}, // Split-core CT, 600A, 600A:26.6mA, 55mm (2.17") Hole Diameter, ESCT-055-600
  '9050962427965': {variantId: '7645601923133', quantity: 2}, // Split-core CT, 800A, 800A:26.6mA, 65mm (2.56") Hole Diameter, SCT-065-800
  '9050962460733': {variantId: '7645601890365', quantity: 2}, // Solid-core CT, 800A, 800A:26.6mA, 80mm (3.15") Hole Diameter, BCT-080-800
  '40540649783357': {variantId: '39342394441789', quantity: 2}, // Split-core Outdoor CT, 800A, 800A:26.6mA, 63x33mm (2.48"x1.3") Hole Diameter, OSCT-063x033-800
  '31187095060541': {variantId: '29380262494269', quantity: 2}, // Split-Core CT, 1500A, 1500A:26.6mA, 90x50mm (3.54x1.97") Hole Diameter, ESCT-090x050-1500
  '29491146129469': {variantId: '29380263575613', quantity: 2}, // Split-core CT, 3000A, 3000A:26.6mA, 120x80mm (4.72x3.15") Hole Diameter, ESCT-120x080-3000
  '9050962559037': {variantId: '7645608443965', quantity: 2}, // Split-Core CT, 5000A, 5000A:26.6mA, 180mm(7.09") x 130mm(5.12") Hole Diameter SCT-180x130-5000
  
  // Current Transformer x3
  '32893798809661': {variantId: '29380251975741', quantity: 3}, // Solid-core CT, 200A, 200A:26.6mA, 13mm (0.51") Hole Diameter, EBCT-013-200UL
  '9051032977469': {variantId: '7645601464381', quantity: 3}, // Solid-core CT, 200A, 200A:26.6mA, 15mm (0.59") Hole Diameter, BCT-015-200
  '40253599907901':  {variantId: '29380260495421', quantity: 3}, // Split-Core CT, 200A, 200A:26.6mA, 15mm (0.6") Hole Diameter, ESCT-015-200UL
  '40253601480765':  {variantId: '29380257382461', quantity: 3}, // Solid-Core CT, 200A, 200A:26.6mA, 19mm (0.75") Hole Diameter, EBCT-019-200UL
  '9051033010237': {variantId: '7645601071165', quantity: 3}, // Solid-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-200
  '9051033436221': {variantId: '7645059219517', quantity: 3}, // Piercing Split-Core Current Transformer, 200A, 200A:26.6mA, 19mm (0.748") Hole Diameter, PSCT-019-200
  '9051033468989': {variantId: '7645608345661', quantity: 3}, // Split-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, SCT-025-200
  '32084172734525': {variantId: '29380260790333', quantity: 3}, // Split-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, ESCT-025-400UL
  '9051033829437': {variantId: '7645601726525', quantity: 3}, // Solid-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-400
  '9051033862205': {variantId: '7645601824829', quantity: 3}, // Split-core CT, 400A, 400A:26.6mA, 32mm (1.26") Hole Diameter, SCT-032-400
  '9051033894973': {variantId: '7645601857597', quantity: 3}, // Solid-core CT, 600A, 600A:26.6mA, 45mm (1.77") Hole Diameter, BCT-045-600
  '29382177783869': {variantId: '29380261871677', quantity: 3}, // Split-core CT, 600A, 600A:26.6mA, 55mm (2.17") Hole Diameter, ESCT-055-600
  '9051033927741': {variantId: '7645601923133', quantity: 3}, // Split-core CT, 800A, 800A:26.6mA, 65mm (2.56") Hole Diameter, SCT-065-800
  '9051033960509': {variantId: '7645601890365', quantity: 3}, // Solid-core CT, 800A, 800A:26.6mA, 80mm (3.15") Hole Diameter, BCT-080-800
  '40540651585597': {variantId: '39342394441789', quantity: 3}, // Split-core Outdoor CT, 800A, 800A:26.6mA, 63x33mm (2.48"x1.3") Hole Diameter, OSCT-063x033-800
  '31187169148989': {variantId: '29380262494269', quantity: 3}, // Split-Core CT, 1500A, 1500A:26.6mA, 90x50mm (3.54x1.97") Hole Diameter, ESCT-090x050-1500
  '29491148652605': {variantId: '29380263575613', quantity: 3}, // Split-core CT, 3000A, 3000A:26.6mA, 120x80mm (4.72x3.15") Hole Diameter, ESCT-120x080-3000
  '9051034124349': {variantId: '7645608443965', quantity: 3}, // Split-Core CT, 5000A, 5000A:26.6mA, 180mm(7.09") x 130mm(5.12") Hole Diameter SCT-180x130-5000
  
  // Current Transformer (Pulse Package)
  '32893795106877': '29380251975741', // Solid-core CT, 200A, 200A:26.6mA, 13mm (0.51") Hole Diameter, EBCT-013-200UL
  '12290625110077': '7645601464381', // Solid-core CT, 200A, 200A:26.6mA, 15mm (0.59") Hole Diameter, BCT-015-200
  '40253595058237': '29380260495421', // Split-Core CT, 200A, 200A:26.6mA, 15mm (0.6") Hole Diameter, ESCT-015-200UL
  '40253596303421': '29380257382461', // Solid-Core CT, 200A, 200A:26.6mA, 19mm (0.75") Hole Diameter, EBCT-019-200UL
  '12290625142845': '7645601071165', // Solid-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-200
  '12290625175613': '7645059219517', // Piercing Split-Core Current Transformer, 200A, 200A:26.6mA, 19mm (0.748") Hole Diameter, PSCT-019-200
  '12290625404989': '7645608345661', // Split-core CT, 200A, 200A:26.6mA, 25mm (0.98") Hole Diameter, SCT-025-200
  '32084167327805': '29380260790333', // Split-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, ESCT-025-400UL
  '12290625503293': '7645601726525', // Solid-core CT, 400A, 400A:26.6mA, 25mm (0.98") Hole Diameter, BCT-025-400
  '12290625536061': '7645601824829', // Split-core CT, 400A, 400A:26.6mA, 32mm (1.26") Hole Diameter, SCT-032-400
  '12290625568829': '7645601857597', // Solid-core CT, 600A, 600A:26.6mA, 45mm (1.77") Hole Diameter, BCT-045-600
  '29382109364285': '29380261871677', // Split-core CT, 600A, 600A:26.6mA, 55mm (2.17") Hole Diameter, ESCT-055-600
  '12290625863741': '7645601923133', // Split-core CT, 800A, 800A:26.6mA, 65mm (2.56") Hole Diameter, SCT-065-800
  '12290625896509': '7645601890365', // Solid-core CT, 800A, 800A:26.6mA, 80mm (3.15") Hole Diameter, BCT-080-800
  '40540647096381': '39342394441789', // Split-core Outdoor CT, 800A, 800A:26.6mA, 63x33mm (2.48"x1.3") Hole Diameter, OSCT-063x033-800
  '12290626420797': '29380262494269', // Split-Core CT, 1500A, 1500A:26.6mA, 90x50mm (3.54x1.97") Hole Diameter, ESCT-090x050-1500
  '29491141836861': '29380263575613', // Split-core CT, 3000A, 3000A:26.6mA, 120x80mm (4.72x3.15") Hole Diameter, ESCT-120x080-3000
  '12290628452413': '7645608443965', // Split-Core CT, 5000A, 5000A:26.6mA, 180mm(7.09") x 130mm(5.12") Hole Diameter SCT-180x130-5000 
  
  /******** EKM Push3 ********/
  
    // EKM Push3 Data System
  '39320368447549': '31282922848317', // EKM Push3 Gateway
  '39320366088253': '7645608050749', // 12V DC Power Supply - 1000mA, UL & cUL Listed, 60Hz
  '39320366284861': '29537678032957', // DIN Rail Mounting 12V DC Power Supply - 100–240VAC, 0.5A In - 12VDC, 1.25A Out, UL, 50/60Hz
 
   // 12V Power Supply
  '39321843236925': '7645608050749', // 12V DC Power Supply - 1000mA, UL & cUL Listed, 60Hz
  '39321843269693': '29537678032957', // DIN Rail Mounting 12V DC Power Supply - 100–240VAC, 0.5A In - 12VDC, 1.25A Out, UL, 50/60Hz
  
  // EKM Push3 Gateway
  '39323606745149': '31282922848317', // EKM Push3 Gateway
  
  /******** Enclosures ********/  
  
  // Enclosure
  '9050963345469': '7644996894781', // Watertight Enclosure with Hinged and Latching Lid - UL Listed - 5.32” x 7.28” x 3.35"
  '9050963378237': '7645608181821', // Watertight Enclosure with Hinged and Latching Lid - UL Listed - 6.7” x 10.63” x 4.33"
  '39352694734909': '39349853388861', // Watertight Enclosure with Hinged and Latching Lid - UL Listed - 11.8” x 11.8” x 5.9"
  '9050963411005': '7645600743485', // Indoor Enclosure Kit EKM-IENC  
  
  
  /******** Accessories ********/
  
  // 120V Meter Package Accessories
  //'9033238446141': '7645603070013', // 1 x EKM Push2 Data System
  //'39310153449533': '31282922848317', // 1 x EKM Push3 Data System
  '9033238511677': '7645602611261', // 1 x EKM Blink - RS-485 to USB Converter
  '9033238675517': '7645602676797', // 1 x EKM Inline Fuse Holder w/ 1 amp Fuse
  '9033238708285': {variantId: '7645602807869', quantity: 2}, // 2 x EKM Insulation Piercing Connector
  '9033239232573': '7645608017981', // 1 x Sticker Label Sheet
  '9033239396413': '7645603233853', // 1 x 4-Twisted Pairs of Wire, CAT5e RS-485 Shielded, Stranded PVC Cable (FTP), 50 feet
  '39352716689469': '39349416198205', // 4 Terminal Watertight Junction Box  
  '9033239429181': '7645607231549', // 1 x 3 Ft. Ethernet Cable
  '13306445168701': {variantId: '7645602545725', quantity: 2}, // 2 x EKM 485Bee - Zigbee Wireless Nodes
  //'13306449231933': '7645608050749', // 1 x 12V DC Power Supply
  '13306452672573': '13305910362173', // 1 x 12V DC Splitter
  
  // 120/240V Meter Package Accessories  
  //'9050970423357': '7645603070013', // 1 x EKM Push2 Data System
  //'39310167998525': '31282922848317', // 1 x EKM Push3 Data System
  '9050970587197': '7645602611261', // 1 x EKM Blink - RS-485 to USB Converter
  '9050970619965': {variantId: '7645602676797', quantity: 2}, // 2 x EKM Inline Fuse Holder w/ 1 amp Fuse
  '9050970652733': {variantId: '7645602807869', quantity: 3}, // 3 x EKM Insulation Piercing Connector
  '9050970685501': '7645608017981', // 1 x Sticker Label Sheet
  '9050970718269': '7645603233853', // 1 x 4-Twisted Pairs of Wire, CAT5e RS-485 Shielded, Stranded PVC Cable (FTP), 50 feet
  '39352726224957': '39349416198205', // 4 Terminal Watertight Junction Box  
  '9050970751037': '7645607231549', // 1 x 3 Ft. Ethernet Cable
  '13306503233597': {variantId: '7645602545725', quantity: 2}, // 2 x EKM 485Bee - Zigbee Wireless Nodes
  //'13306504970301': '7645608050749', // 1 x 12V DC Power Supply
  '13306506215485': '13305910362173', // 1 x 12V DC Splitter
  
  // 3-Phase 3-Wire Meter Package Accessories    
  //'9051014463549': '7645603070013', // 1 x EKM Push2 Data System
  // '39310169210941': '31282922848317', // 1 x EKM Push3 Data System
  '9051015217213': '7645602611261', // 1 x EKM Blink - RS-485 to USB Converter
  '9051018199101': {variantId: '7645602676797', quantity: 3}, // 3 x EKM Inline Fuse Holder w/ 1 amp Fuse
  '9051019706429': {variantId: '7645602807869', quantity: 3}, // 3 x EKM Insulation Piercing Connector
  '9051020460093': '7645608017981', // 1 x Sticker Label Sheet
  '9051020492861': '7645603233853', // 1 x 4-Twisted Pairs of Wire, CAT5e RS-485 Shielded, Stranded PVC Cable (FTP), 50 feet
  '39352730124349': '39349416198205', // 4 Terminal Watertight Junction Box  
  '9051021344829': '7645607231549', // 1 x 3 Ft. Ethernet Cable
  '13306508935229': {variantId: '7645602545725', quantity: 2}, // 2 x EKM 485Bee - Zigbee Wireless Nodes
  //'13306510377021': '7645608050749', // 1 x 12V DC Power Supply
  '13306511130685': '13305910362173', // 1 x 12V DC Splitter
  
  // 3-Phase 4-Wire Meter Package Accessories      
  //'9051073052733': '7645603070013', // 1 x EKM Push2 Data System
  // '39310170095677': '31282922848317', // 1 x EKM Push3 Data System
  //'9051074297917': '7645607985213', // 1 x EKM Dash -- Software Registration Key (dashkey)
  '9051074330685': '7645602611261', // 1 x EKM Blink - RS-485 to USB Converter
  '9051074396221': {variantId: '7645602676797', quantity: 3}, // 3 x EKM Inline Fuse Holder w/ 1 amp Fuse
  '9051074428989': {variantId: '7645602807869', quantity: 4}, // 4 x EKM Insulation Piercing Connector
  '9051074527293': '7645608017981', // 1 x Sticker Label Sheet
  '9051074592829': '7645603233853', // 1 x 4-Twisted Pairs of Wire, CAT5e RS-485 Shielded, Stranded PVC Cable (FTP), 50 feet
  '39352732975165': '39349416198205', // 4 Terminal Watertight Junction Box  
  '9051074625597': '7645607231549', // 1 x 3 Ft. Ethernet Cable
  '13306513555517': {variantId: '7645602545725', quantity: 2}, // 2 x EKM 485Bee - Zigbee Wireless Nodes
  //'13306514964541': '7645608050749', // 1 x 12V DC Power Supply
  '13306516340797': '13305910362173', // 1 x 12V DC Splitter
  
  // Pulse Meter Package Accessories
  //'12290530967613': '7645603070013', // 1 x EKM Push2 Communication System
  //'39310170751037': '31282922848317', // 1 x EKM Push3 Data System
  '12290531557437': '7645602611261', // 1 x EKM Blink - RS-485 to USB Converter
  '12290531819581': '7645602676797', // 1 x EKM Inline Fuse Holder w/ 1 amp Fuse
  '12290531885117': '7645602807869', // 1 x EKM Insulation Piercing Connector
  '12290531917885': '7645608017981', // 1 x Sticker Label Sheet
  '12290532081725': '7645603233853', // 1 x 4-Twisted Pairs of Wire, CAT5e RS-485 Shielded, Stranded PVC Cable (FTP), 50 feet
  '39352734646333': '39349416198205', // 4 Terminal Watertight Junction Box  
  '12290532114493': '7645607231549', // 1 x 3 Ft. Ethernet Cable 
  '13306397360189': {variantId: '7645602545725', quantity: 2}, // 2 x EKM 485Bee - Zigbee Wireless Nodes
  //'13306030129213': '7645608050749', // 1 x 12V DC Power Supply
  '13306051264573': '13305910362173', // 1 x 12V DC Splitter
};

var SUCCESS_TEMPLATE = '<div class="product-cart-message" data-product-message="">Your products have been successfully added to your <a href="/cart">cart</a>. Feel free to <a href="/collections/all">continue shopping</a> or <a href="/checkout" class="bold_hidden" data-event-queue-button="0" style="display: none;">check out</a><a href="/checkout" class="bold_clone" data-event-queue-button="0">check out</a>.</div>';

function addToCart(event) {
  event.preventDefault();
  
  /* TODO: Could enable this so user doesn't spam Add to Cart by accident
  if (this.processing) {
    return;
  }
  this.processing = true;
  */
    
  if (Modernizr.cssanimations) {
	$(".add-to-cart").addClass("loading");
  } else {
    $('input[type="submit"]').val(this.productSettings.processingText);
  }
  
  var quantitiesInputValue = $('input[name="properties[_boldVariantQtys]"]').val();  
  var variantQuantities = [];
  if(typeof quantitiesInputValue != 'undefined') {    
    variantQuantities = quantitiesInputValue.split(",");
  }
  
  var updateData = {};
  var optionVariantIds = $('input[name="properties[_boldVariantIds]"]').val().split(",");  
  var index;

  for (index = 0; index < optionVariantIds.length; index++) {
    var optionVariantId = optionVariantIds[index];
    
    // TODO: we should check for the mapping and if it doesn't exist we should put an error message
    var productVariantResult = PRODUCT_MAPPING[optionVariantId];
    var productQuantity = 1;
    var productVariantId;
    if (typeof productVariantResult === "string") {
      productVariantId = productVariantResult;
    } else {
      productVariantId = productVariantResult['variantId'];
      productQuantity = productVariantResult['quantity'];
    }
    
    // TODO: check for product variant inventory level. A 0 level should remove varient from options.    
    if(variantQuantities.length > 0) {
      var variantQuantity = variantQuantities[index];
      var cleanedVariantQuantity = parseInt(variantQuantity.replace(/\*/g, ''));
      productQuantity = productQuantity * cleanedVariantQuantity;
    }
    
    var packageQuantity = parseInt($('input[name="quantity"]').val());
	updateData[productVariantId] = packageQuantity * productQuantity;
  }  
  
  $.ajax({
    type: 'POST',
    url: '/cart/update', 
    data: {updates: updateData},
    dataType: 'json',
    success: function(data) {
        var successMessage;
		$(".header-cart-link .header-cart-count").text(data.item_count);
        successMessage = SUCCESS_TEMPLATE;
        $("[data-product-message]").html(successMessage);
        $('input[name="quantity"]').removeClass("error");
        $(".add-to-cart").removeClass("loading added-error").addClass("added-success");        
        $(".header-cart-count").addClass("active");
        if (!Modernizr.cssanimations) {
          $(".add-to-cart").val(Theme.addToCartText);
        }
		// return _this.processing = false;
    },
      error: function(data) {
      }
  });  
}


document.addEventListener('DOMContentLoaded', function() {
  $('input[type="submit"]').click(function(event){ addToCart(event); });
});